import { Component, h, Host, Prop, State } from '@stencil/core';
import { Swiper, SwiperOptions, Autoplay, EffectFade } from 'swiper';
import { getCSSVarValue, hexToRgb } from './../../../utils/utils';


@Component({
  tag: 'afs-swiper-banner',
  styleUrl: 'afs-swiper-banner.scss',
  shadow: false,
  scoped: false,
})
export class AfsSwiperBanner {

  swiperWrapper! : HTMLElement;

  @Prop({ mutable: true }) gradientColor : string;
  @Prop() swiperDelay : number = 4000;
  @Prop() swiperSpeed : number = 700;
  @Prop() gradientHeight : number = 40;
  @Prop() responsiveOffset : boolean = false;
  @Prop() offset : number = 25;
  @Prop() maxHeight : string = "90vh";
  @Prop() ctaWinner : boolean = false;
  @Prop() cta : boolean = false;
  @Prop() noFade : boolean = false;
  @Prop() ratioLock : boolean = false;

  swiperParams : SwiperOptions = {
    loop: true,
    autoplay: {
      delay: this.swiperDelay,
      disableOnInteraction: false
    },
    speed: this.swiperSpeed,
  }

  @State() swiper : Swiper = null;

  componentWillLoad() {
    if (this.gradientColor && this.gradientColor.includes('var(')) {
        this.gradientColor = getCSSVarValue(this.gradientColor);
    }
  }

  componentDidLoad() {
    if (this.cta || this.ctaWinner) return;
    Swiper.use([Autoplay, EffectFade]);
    this.swiper = new Swiper('.swiper-container.swiper-container-banner', {...this.swiperParams, effect: !this.noFade ? 'fade' : 'slide', fadeEffect: { crossFade: this.swiperWrapper.children.length > 3 && !this.noFade ? true : false }});
  }

  render() {
    const gradientRGB = this.gradientColor ? hexToRgb(this.gradientColor) : null;

    return (
      <Host style={{
        display: 'block',
        position: 'relative',
        zIndex: '-1',
      }}>
        <div class={`swiper-container swiper-container-banner ${this.responsiveOffset && 'responsive-offset'} ${this.ratioLock ? 'ratio-lock' : 'no-lock'} ${this.ctaWinner && 'cta-winner-mode'} ${this.cta && 'cta-mode'}`} style={{
          '--max-height': this.maxHeight,
          '--responsive-offset-value': `${this.offset}`,
        }}>
          <div class="swiper-wrapper swiper-wrapper-banner" ref={el => this.swiperWrapper = el as HTMLElement}>
            <slot />
          </div>
          {this.gradientColor && <div class="swiper-gradient" style={{ 
            background: this.gradientColor ? `linear-gradient(0deg, rgba(${gradientRGB.r},${gradientRGB.g},${gradientRGB.b},1) 0%, rgba(${gradientRGB.r},${gradientRGB.g},${gradientRGB.b},0) 100%)` : "transparent",
            height: `calc(100vw * 9/16 * ${ this.gradientHeight / 100 })`
          }}></div>}
        </div>
      </Host>
    );
  }

}
